<template>
  <div class="main-content-container overflow-hidden">
    <PageTitle pageTitle="Data VesselType" subTitle="Forms" />

    <ListVesselType />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PageTitle from "@/components/Common/PageTitle.vue";
import ListVesselType from "@/components/Pages/Master/VesselType/ListVesselType.vue";

export default defineComponent({
  name: "ListVesselTypePage",
  components: {
    PageTitle,
    ListVesselType,
  },
});
</script>
